import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <span className="text-xl font-bold">力量举工作室</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              专业力量训练计划和教练服务。
              我们通过专业指导和经过验证的训练方法帮助运动员和健身爱好者实现他们的目标。
            </p>
            <div className="flex space-x-4">
              <button
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </button>
              <button
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.004 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.344-1.297C4.184 14.794 3.662 13.644 3.662 12.347c0-1.297.522-2.448 1.443-3.344.921-.896 2.072-1.418 3.344-1.418 1.297 0 2.448.522 3.344 1.418.896.896 1.418 2.047 1.418 3.344 0 1.297-.522 2.447-1.418 3.344-.896.807-2.047 1.297-3.344 1.297zm7.718-9.011h-1.418v1.418h1.418v-1.418zm0 2.836h-1.418v1.418h1.418v-1.418z"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">快速链接</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors">
                  服务
                </Link>
              </li>
              <li>
                <Link to="/programs" className="text-gray-400 hover:text-orange-400 transition-colors">
                  计划
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-400 hover:text-orange-400 transition-colors">
                  评价
                </Link>
              </li>
              <li>
                <Link to="/coaches" className="text-gray-400 hover:text-orange-400 transition-colors">
                  教练
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h3 className="text-lg font-semibold mb-4">帮助</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-orange-400 transition-colors">
                  服务条款
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-orange-400 transition-colors">
                  隐私政策
                </Link>
              </li>
              <li>
                <Link to="/subscription" className="text-gray-400 hover:text-orange-400 transition-colors">
                  管理订阅
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>版权所有 2025 © 保留所有权利。由 Spxcorp Ltd 设计</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 